import { Mail } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { CardAction } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { useCompanyPath, useIdCompany, useRBAC } from '@/lib/hooks'
import { isCompanyDeveloper } from '@/lib/rbac'

type Props = {
  canInvite?: boolean
  filterTerm: string
  onInvite?: () => void
  setFilterTerm: (term: string) => void
}

export const UsersTableHeader = ({
  canInvite,
  filterTerm,
  onInvite,
  setFilterTerm,
}: Props) => {
  const { idCompany } = useIdCompany()
  const { navigateToPath } = useCompanyPath()
  const { rbac, rolesInCompany } = useRBAC()
  const isInviteEnabled =
    canInvite ??
    (rbac.company(idCompany).users.update.can() ||
      isCompanyDeveloper(rolesInCompany))

  return (
    <CardAction className="w-full px-6 flex items-center gap-2 justify-between">
      <Input
        autoFocus
        placeholder="Filter by name..."
        aria-label="Filter users by name"
        value={filterTerm}
        onChange={(e) => setFilterTerm(e.target.value)}
        className="max-w-sm"
      />
      {isInviteEnabled ? (
        <Button
          onClick={
            onInvite ??
            (() =>
              navigateToPath({
                pathname: '/user-management/invite-users',
                options: { replace: true },
              }))
          }
        >
          <Mail aria-hidden="true" /> Invite users
        </Button>
      ) : null}
    </CardAction>
  )
}
